module.exports = __webpack_public_path__ + "img/cisco-2.2f7172c5.jpg";